<div class="loading-container" *ngIf="isLoading">
  <div class="loading">
    <mat-spinner strokeWidth="2" diameter="42"></mat-spinner>
    <div>Loading...</div>
  </div>
</div>
